import { apiGet, apiPost, apiPatch, apiDelete } from './api';
import type { TeamMember, InviteRequest } from '../types/team';

export async function getTeam(): Promise<TeamMember[]> {
  const response = await apiGet<{ team: TeamMember[] }>('/team');
  return response.team;
}

export async function inviteMember(data: InviteRequest): Promise<TeamMember> {
  return apiPost<TeamMember>('/team', data);
}

export async function setMemberRole(username: string, role: string): Promise<TeamMember> {
  return apiPatch<TeamMember>(`/team/${encodeURIComponent(username)}`, { role });
}

export async function removeMember(username: string): Promise<void> {
  return apiDelete(`/team/${encodeURIComponent(username)}`);
}
